import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { site, pages } from "../config/settings";

import Header from '../components/Header'

import '../theme/style.sass'
import logo from "../images/logo.png"
import Footer from '../components/Footer';

class TemplateWrapper extends Component {
  componentDidMount() {
    if (!document.getElementById('webfontloader')) {
      (function (d) {
        var wf = d.createElement('script'), s = d.scripts[0];
        wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
        wf.async = true;
        wf.id = 'webfontloader';

        wf.onload = () => {
          WebFont.load({
            google: {
              families: ['Comfortaa:300,400,500,700'],
            },
          });
        };

        s.parentNode.insertBefore(wf, s);
      })(document);
    }
  }

  renderHead({ title, url, description, keywords }) {
    const path = this.props.location.pathname
    const locale = path.match(/^en/)
      ? 'en'
      : 'ja'
    return (
      <Helmet>
        <html lang={locale} />
        <title itemProp="name" lang={locale}>{title || site.title.default}</title>
        <meta charSet="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE-edge,chrome=1" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <meta name="description" content={description || site.description} />
        <meta name="keywords" content={keywords || site.keywords} />

        <link rel="canonical" href={`${site.url}${path}`} />
        {/* {locales.map((locale) => {
          <link rel="alternate" href={`${site.url}/${locale}/${path}`} hrefLang={locale} />
        })} */}

        <meta property="og:title" content={title} />
        <meta property="og:type" content="website" />
        {url && <meta property="og:url" content={url} />}
        <meta property="og:image" content={logo} />
        <meta
          property="og:description"
          content={description || site.description}
        />
        {/* <meta property="fb:app_id" content={} /> */}
      </Helmet>
    )
  }
  renderContact() {
    const path = this.props.location.pathname
    const page = pages.find(page => (page.path === path))
    const locale = path.match(/^en/)
      ? '/en'
      : ''

    return (
      <div>
        {this.renderHead(page)}
        <Header nav={false} locale={locale} />
        <main>
          {this.props.children()}
        </main>
      </div>
    );
  }
  render() {
    const path = this.props.location.pathname
    const page = pages.find(page => (page.path === path))
    const locale = path.match(/^\/en/)
      ? '/en'
      : ''

    if (path === '/contact') {
      return this.renderContact();
    }

    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}>
        {this.renderHead(page || {})}
        <Header locale={locale} />

        <main>
          {this.props.children()}
        </main>


        <Footer />
      </div>
    )
  }
}
TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js